export enum BusinessVerificationStatus {
  NOT_STARTED = 'NOT_STARTED',
  SUBMITTED = 'SUBMITTED',
  RUNNING = 'RUNNING',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
}

export enum BusinessVerificationDecision {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  REVIEW = 'REVIEW',
  MANUAL_REVIEW = 'MANUAL_REVIEW',
  FAILED = 'FAILED',
  UNKNOWN = 'UNKNOWN',
}

export enum BusinessVerificationLifecycleStatus {
  PROFILE_NOT_SUBMITTED = 'PROFILE_NOT_SUBMITTED',
  ONBOARDING_SESSIONS_PENDING = 'ONBOARDING_SESSIONS_PENDING',
  READY_FOR_REVIEW = 'READY_FOR_REVIEW',
  ADDITIONAL_INFO_REQUESTED = 'ADDITIONAL_INFO_REQUESTED',
  MONITORING_UPDATES = 'MONITORING_UPDATES',
  SESSIONS_EXPIRED = 'SESSIONS_EXPIRED',
  UNKNOWN = 'UNKNOWN',
}

export interface BusinessVerificationDto {
  businessProfileId: string;
  profileUrl: string | null;
  status: BusinessVerificationStatus;
  decision: BusinessVerificationDecision | null;
  lifecycleStatus: BusinessVerificationLifecycleStatus | null;
  errorCode: string | null;
  errorReason: string | null;
  profileCreatedAt: string | null;
  profileUpdatedAt: string | null;
  lastActivityAt: string | null;
}

export interface BusinessVerificationSessionResponse {
  embedUrl: string;
  status: BusinessVerificationStatus;
  stepsCompleted: number;
  totalSteps: number;
}

export interface ItemBusinessVerificationConfig {
  provider: 'AIPRISE';
  totalSteps: number;
  description?: string;
  requirements?: string[];
  estimatedTime?: string;
}

export enum ItemConfigActionType {
  REDIRECT = 'REDIRECT',
}

export interface ItemConfigRedirectAction {
  label: string;
  type: ItemConfigActionType;
  url: string;
  openInNewTab?: boolean;
}

export type ItemConfigAction = ItemConfigRedirectAction;

export interface ItemConfigJson {
  businessVerification?: ItemBusinessVerificationConfig;
  actions?: ItemConfigAction[];
}

export enum DocumentVerificationStatus {
  NOT_STARTED = 'NOT_STARTED',
  SUBMITTED = 'SUBMITTED',
  RUNNING = 'RUNNING',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum DocumentVerificationResult {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  REVIEW = 'REVIEW',
  MANUAL_REVIEW = 'MANUAL_REVIEW',
  FAILED = 'FAILED',
  UNKNOWN = 'UNKNOWN',
}

export interface FieldDocumentVerificationConfig {
  enabled: boolean;
  provider: 'AIPRISE';
  documentType: string;
}

export enum ItemDocumentVerificationRunStatus {
  PENDING = 'PENDING',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface ItemDocumentVerificationResultDetails {
  result: DocumentVerificationResult | null;
  decisionReason: string | null;
  extractedData: Record<string, string | null> | null;
}
export enum DOCUMENT_VERIFICATION_FAILURE_CODES {
  PASSWORD_PROTECTED_PDF = 'PASSWORD_PROTECTED_PDF',
}

export interface ItemDocumentVerificationDto {
  id: string;
  type: string;
  attachmentId: string;
  fileName: string;
  status: ItemDocumentVerificationRunStatus;
  completedAt: string | null;
  failureReason: string | null;
  lastRequestedAt: string | null;
  retryable: boolean;
  failureCode: DOCUMENT_VERIFICATION_FAILURE_CODES | null;
  resultDetails: ItemDocumentVerificationResultDetails | null;
}
